import {Component, React} from '$src/handy'
import {observer} from 'mobx-react'
import {Redirect} from 'react-router-dom'

@observer
export default class RedirectFromIndex extends Component<{}, {}> {
  render() {
    return this.store.auth.getState().isLoggedIn ?
    <Redirect to={{pathname: '/projects'}} /> :
    <Redirect to={{pathname: '/login'}} />
  }
}



// WEBPACK FOOTER //
// ./src/bootstrap/routing/RedirectFromIndex.tsx